import i18n from '@src/i18n'
import { UsersService } from '@services/users.service'
import { fullName } from '@src/utils/settings/tenant-user.util.js'

const t = i18n?.global?.t

export default {
  setupUser({ commit }, payload) {
    commit('SET_ACTIVE_USER', payload)
    commit('SET_CURRENT_ROLE', 'student')
  },
  storeShortBio({ state, commit, rootState }, payload) {
    const data = {
      short_bio: payload,
    }

    return new Promise((resolve, reject) => {
      UsersService.storeShortBio(data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
        })
    })
  },

  uploadUserImage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.uploadUserImage(payload)
        .then((response) => {
          resolve(response.data)
          commit(
            'toast/NEW',
            { message: t(`toast.Image Uploaded Successfully`), type: 'success' },
            { root: true },
          )
        })
        .catch((error) => {
          reject(error)
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
        })
    })
  },

  getShow({ state, commit, rootState }, payload) {},

  getUserDetails({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      UsersService.getUserById(id, payload)
        .then((response) => {
          let user = response.data
          fullName(user?.user_details)
          resolve(response, response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPickupPersonDetails({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      UsersService.getPickupPersonById(id, payload)
        .then((response) => {
          response.data.records.forEach((user) => {
            fullName(user)
          })
          resolve(response, response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getMyPickupPersonDetails({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      UsersService.getMyPickupPersonById(id, payload)
        .then((response) => {
          response.data.records.forEach((user) => {
            fullName(user)
          })
          resolve(response, response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getGuardiansOfDetails({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      UsersService.getGuardianOfById(id, payload)
        .then((response) => {
          response.data.records.forEach((user) => {
            fullName(user)
          })
          resolve(response, response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSectionStudentDetails({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      UsersService.getSectionStudentById(id, payload)
        .then((response) => {
          response.data.records.forEach((user) => {
            fullName(user)
          })
          resolve(response, response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSectionTeacherDetails({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      UsersService.getSectionTeacherById(id, payload)
        .then((response) => {
          response.data.records.forEach((user) => {
            fullName(user)
          })
          resolve(response, response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCampusAdminDetails({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      UsersService.getCampusAdminById(id, payload)
        .then((response) => {
          response.data.records.forEach((user) => {
            fullName(user)
          })
          resolve(response, response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getStaffDetails({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      UsersService.getStaffById(id, payload)
        .then((response) => {
          response.data.records.forEach((user) => {
            fullName(user)
          })
          resolve(response, response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  revokeUserEntityPermission({ commit }, id) {
    return new Promise((resolve, reject) => {
      UsersService.revokeUserEntityPermission(id)
        .then((response) => {
          resolve(response, response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
  getPickupPersonStudents({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.getPickupPersonStudents(payload)
        .then((response) => {
          resolve(response, response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
  getGuardianStudents({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.getGuardianStudents(payload)
        .then((response) => {
          resolve(response, response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
  getTeacherClassesSections({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.getTeacherClassesSections(payload)
        .then((response) => {
          resolve(response, response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
  getStudentClassesSections({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.getStudentClassesSections(payload)
        .then((response) => {
          resolve(response, response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  /* ENABLE DISABLE USER LOGIN */

  enableUserLogin({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.enableUserLogin(payload)
        .then((response) => {
          commit(
            'toast/NEW',
            { message: 'User Login Enabled Successfully', type: 'success' },
            { root: true },
          )
          resolve(response)
        })
        .catch((error) => {
          commit('layout/IS_LOADING', false, { root: true })
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  disableUserLogin({ commit }, id) {
    return new Promise((resolve) => {
      UsersService.disableUserLogin(id)
        .then((response) => {
          commit(
            'toast/NEW',
            { message: 'User Login Disabled Successfully', type: 'success' },
            { root: true },
          )
          resolve(response)
        })
        .catch((error) => {
          commit('layout/IS_LOADING', false, { root: true })
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  // Forgot Owner Password
  forgotOwnerPassword({ state, commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.forgotOwnerPassword(payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  resetOwnerPassword({ state, commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.resetOwnerPassword(payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  // Forgot User Password
  getForgetPasswordPreInfo({ state, commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.getForgetPasswordPreInfo(payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  forgotPassword({ state, commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.forgotPassword(payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  setupUserPassword({ state, commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.setupUserPassword(payload)
        .then((response) => {
          commit(
            'toast/NEW',
            { type: 'success', message: 'Password Set Successfully' },
            { root: true },
          )
          resolve(response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
  resetPassword({ state, commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.resetPassword(payload)
        .then((response) => {
          commit(
            'toast/NEW',
            { type: 'success', message: t(`toast.Reset Password Successfully`) },
            { root: true },
          )
          resolve(response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  resendUserSetupPassword({ state, commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      UsersService.resendUserSetupPassword(payload)
        .then((response) => {
          commit(
            'toast/NEW',
            { type: 'success', message: 'Email resent successfully' },
            { root: true },
          )
          resolve(response.data)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
}
